import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {Subscription} from 'rxjs';
import {
    AssignDialogService,
} from '@component/exam/assign-dialog/assign-dialog.service';
import {ApiExamPlanInterface, AppExamService} from '@component/exam/exam.service';

@Component({
    selector: 'app-exam-delete-dialog',
    templateUrl: './exam-delete-dialog.component.html',
    styleUrls: ['./exam-delete-dialog.component.scss'],
    providers: [
        AssignDialogService,
    ],
})
export class ExamDeleteDialogComponent implements OnDestroy {
    readonly #assignDialogService: AppExamService;

    readonly buttonType = ButtonTypeEnum;

    #subscriptions: Subscription[] = [];

    #dialogRef: MatDialogRef<ExamDeleteDialogComponent>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: ApiExamPlanInterface,
        dialogRef: MatDialogRef<ExamDeleteDialogComponent>,
        appExamService: AppExamService,
    ) {
        this.#dialogRef = dialogRef;
        this.#assignDialogService = appExamService;
    }

    ngOnDestroy(): void {
        this.#subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    cancel(): void {
        this.#dialogRef.close(false);
    }

    delete(): void {
        this.#assignDialogService.delete(String(this.dialogData.id))
            .subscribe((result: any) => this.#dialogRef.close(true));
    }
}
